// **************************************************
// Product Categories Toggle
// **************************************************

// eslint-disable-next-line no-unused-vars
const slideToggleProductCategories = (element) => {
  const button = element.dataset.id ? element : element.closest('.product-categories__button');

  if (!button) return;

  if (button.classList.contains('product-categories__button')) {
    const parent = button.closest('.product-categories__item');
    const content = parent.querySelector('.product-categories__content');
    parent.classList.toggle('is-open');
    if (content) {
      slideToggle(content, 300, 'block');
      const subItems = content.querySelectorAll('.product-categories__sub-item');
      if (!parent.classList.contains('is-open')) {
        subItems.forEach((item) => {
          item.classList.remove('is-active');
        });
      }
    }
  }
};
